(function() {
  var overlay = document.querySelector('[data-parallax-product]');
  if (!overlay) return;

  var hero = overlay.closest('.hero');
  if (!hero) return;

  function isMobile() {
    return window.innerWidth < 750;
  }

  function getSpeed() {
    if (isMobile()) {
      return {
        x: parseFloat(overlay.dataset.parallaxXMobile || overlay.dataset.parallaxX || '0'),
        y: parseFloat(overlay.dataset.parallaxYMobile || overlay.dataset.parallaxY || '0.15')
      };
    }
    return {
      x: parseFloat(overlay.dataset.parallaxX || '0'),
      y: parseFloat(overlay.dataset.parallaxY || '0.15')
    };
  }

  window.addEventListener('scroll', function() {
    var rect = hero.getBoundingClientRect();
    var scrolled = -rect.top;
    if (scrolled < -window.innerHeight || scrolled > rect.height) return;
    var speed = getSpeed();
    overlay.style.transform = 'translateX(' + (scrolled * speed.x) + 'px) translateY(' + (scrolled * speed.y) + 'px)';
  }, { passive: true });
})();